/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderEntityTransferCommandFromJSON(json) {
    return WorkorderEntityTransferCommandFromJSONTyped(json, false);
}
export function WorkorderEntityTransferCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'targetLocation1': !exists(json, 'targetLocation1') ? undefined : json['targetLocation1'],
        'targetTrade': !exists(json, 'targetTrade') ? undefined : json['targetTrade'],
        'targetPropertyId': !exists(json, 'targetPropertyId') ? undefined : json['targetPropertyId'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
    };
}
export function WorkorderEntityTransferCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'targetLocation1': value.targetLocation1,
        'targetTrade': value.targetTrade,
        'targetPropertyId': value.targetPropertyId,
        'user': UserToJSON(value.user),
    };
}
